import React, { useState } from 'react';
import { IOrder } from '@/interfaces/order';
import { Button, Col, Row } from 'antd';
import Title from '@/components/title';
import { PlusOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { ISearchMediaReq, ISearchMediaRes } from '@/interfaces/media';
import { searchMedias } from '@/adapters/media';
import MediaCard from '@/components/card/media-card';
import MediaUploader from '@/components/media/uploader-modal';

interface IProps {
  data: IOrder;
}

const _criteria: ISearchMediaReq = {
  orderBy: 'id',
  orderType: 'descend',
  pageSize: -1,
  pageStart: 1,
  search: '',
  modelType: 'delivery-doc',
};

const DeliveryDoc = ({ data }: IProps) => {
  console.log(data);
  const [isUpload, setIsUpload] = useState(false);
  const [criteria] = useState<ISearchMediaReq>({
    ..._criteria,
    modelId: data.id,
  });
  const { data: medias, refetch } = useQuery<
    AxiosResponse<ISearchMediaRes>,
    Error
  >({
    queryKey: ['search-media', criteria],
    queryFn: async () => await searchMedias(criteria),
  });

  const documents = medias?.data?.data || [];
  return (
    <Row gutter={12} className="">
      <Col span={24}>
        <div className="border-2 border-dashed rounded-md px-3 pb-4">
          <Title title="อัพโหลดเอกสาร">
            <Button ghost type="primary" onClick={() => setIsUpload(true)}>
              <PlusOutlined />
              อัพโหลดไฟล์
            </Button>
          </Title>
          <div className="flex flex-col gap-2">
            {documents.map(d => {
              return (
                <MediaCard
                  key={d.id}
                  media={d}
                  onDeleted={() => refetch()}
                  isDownload
                />
              );
            })}
          </div>

          <MediaUploader
            data={{
              modelId: data?.id,
              modelType: criteria.modelType || 'delivery-doc',
            }}
            open={isUpload}
            onCancel={() => setIsUpload(false)}
            onUploaded={() => {
              setIsUpload(false);
              refetch();
            }}
          />
        </div>
      </Col>
    </Row>
  );
};

export default DeliveryDoc;
